export const EXTRA_CONTENT_HEIGHT = 76;
export const PACKAGE_TILE_HEIGHT = 141;
export const CONTENT_OFFSET_BOTTOM = 20;

export const INITIAL_PACKAGES_SET = 1;
export const DEFAULT_QUANTITY_PACKAGES_SKELETON = 2;
